import { app } from '../../../../../app';

app.component('generateCorporateCredentials', {
    bindings: {close: '&', dismiss: '&', resolve: '<'},
    templateUrl: require('./generate-credentials.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/corporate-settings/company-profile/generate-credentials/generate-credentials.component.js